class BundleBuilderV2 extends HTMLElement {
  #items;

  get items() {
    return this.#items;
  }
  set items(value) {
    if (!Array.isArray(value)) {
      console.warn('Invalid data format. Expected an array.');
      return;
    }

    this.#items = structuredClone(value);
  }

  updateData(eventType, data) {
    if (eventType === 'drawer-updated') {
      let items = data.lineItems.map((v) => {
        return {
          id: v.dataset.variantId,
          quantity: v.dataset.quantity,
          properties: { Bundle: 'Bundle-Builder Item' },
          ...(this.isSubscribed() && { selling_plan: v.dataset.sellingPlanId }),
        };
      });

      this.items = items;

      console.debug('drawer-updated, items:', { items });
    }
    this.dispatchEvent(
      new CustomEvent(eventType, {
        detail: data,
        bubbles: true,
        composed: true,
      }),
    );
  }

  toLocaleCurrencyStr = (number) => number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

  isSubscribed() {
    return (
      document.querySelector('bundle-builder-checkout-v2 input[name="checkout-plan"]:checked').id === 'subscription'
    );
  }
}

customElements.define('bundle-builder-v2', BundleBuilderV2);

customElements.define(
  'bundle-builder-grid-v2',
  class BundleBuilderGridV2 extends HTMLElement {
    connectedCallback() {
      // button clicks
      this.addEventListener('click', this.clickHandler.bind(this));

      // Initial click to set the visible tab/step
      this.loadCurrentStep();

      // input events
      this.addEventListener('input', this.inputChangeHandler.bind(this));

      // update all card product quantity input initial states
      this.querySelectorAll('.item-options-selector').forEach((select) => {
        this.updateQtyInputValue(
          select.closest('.bundle-grid-v2--product-card'),
          select.closest('.bundle-grid-v2--product-card')?.dataset?.selectedVariantId,
        );
      });

      // listen for updates from drawer
      document.querySelector('bundle-builder-v2').addEventListener('drawer-updated', (event) => {
        let data = event.detail.lineItems.map((v) => {
          return {
            variantId: Number(v.dataset.variantId),
            quantity: Number(v.dataset.quantity),
          };
        });

        data.forEach((v) => {
          let elem = document.querySelector(`.bundle-grid-v2--product-card[data-selected-variant-id="${v.variantId}"]`);
          let qtyInput = elem?.querySelector('.item-qty-input');

          if (!elem && !qtyInput) return;
          if (Number(qtyInput.value) === Number(v.quantity)) return;

          qtyInput.value = v.quantity;
          qtyInput.setAttribute('value', v.quantity);
        });
      });

      document.querySelector('bundle-builder-v2').addEventListener('line-item-deleted', (event) => {
        let data = event.detail.deletedItem;
        let elem = this.querySelector(`.bundle-grid-v2--product-card[data-selected-variant-id="${data}"]`);
        let qtyInput = elem?.querySelector('.item-qty-input');

        qtyInput.value = 0;
        qtyInput.setAttribute('value', 0);
      });
    }

    // This is specifically just for the dropdown selectors
    inputChangeHandler(e) {
      if (e.target.closest('.item-options-selector')) {
        let data = this.getVariantData(e);
        if (data.variant.id) {
          this.updateSelectedVariantId(e, data.variant.id);
        }

        if (e.target.closest('[data-product-section="Accessories"]')) {
          this.updateAccessoriesImage(
            e.target.closest('.bundle-grid-v2--product-card'),
            data.variant.featured_image.src,
          );
        }
      }
    }

    clickHandler(e) {
      if (e.target.closest('button.bundle-grid-v2--add-product-cta')) {
        this.addItem(this.getVariantData(e));
      }
      if (e.target.closest('input[name="steps"]')) {
        let currentStep = e.target.closest('input[name="steps"]')?.dataset.stepIndex;
        let nextStep = e.target
          .closest('.bundle-grid-v2--steps-wrapper')
          .querySelector(`input[data-step-index="${Number(currentStep) + 1}"]`)?.id;

        if (Number(currentStep) === 3) {
          nextStep = 'Free Gift!';
        }

        if (Number(currentStep) === 4) {
          nextStep = 'Checkout';
        }

        this.saveCurrentStep();

        if (nextStep) {
          document.querySelector('.bundle-steps-button-container button .step').innerHTML =
            `${currentStep < 4 ? 'Next:' : ''} ${nextStep}`;
          document.querySelector('.bundle-steps-button-container button').dataset.currentStep = currentStep;
        }
      }
    }

    getVariantData(e) {
      const heading = e.target.closest('.bundle-grid-v2--product-card').dataset.itemHeading;
      const mainImage = e.target.closest('.bundle-grid-v2--product').querySelector('img').src;
      const variantData = JSON.parse(e.target.closest('.bundle-grid-v2--product').querySelector('script').textContent);
      const selectElem = e.target.closest('.bundle-grid-v2--product-card').querySelector('select');

      const refillPrice = e.target.closest('.bundle-grid-v2--product').dataset.refillPrice;
      const refillText = e.target.closest('.bundle-grid-v2--product').dataset.refillText;

      let data = {};

      if (!selectElem) {
        data = {
          heading,
          image: mainImage,
          variant: variantData.pop(),
          refill: { refillPrice, refillText },
        };

        this.addItem(data);
      } else {
        const isAccesories = e.target.closest('.bundle-grid-v2--main-options-loop') ? false : true;

        const option1 = isAccesories
          ? selectElem[selectElem.selectedIndex].value
          : e.target.closest('.bundle-grid-v2--product-card').dataset.option1;
        const option2 = isAccesories ? null : selectElem[selectElem.selectedIndex].value;

        let variant = variantData.filter((v) => v.option1 == option1);
        if (!isAccesories) {
          variant = variant.filter((v) => v.option2 == option2);
        }
        variant = variant.pop();

        data = {
          heading,
          image: mainImage,
          variant,
          refill: { refillPrice, refillText },
        };
      }

      return data;
    }

    getCurrentLineItems() {
      return document.querySelectorAll('.line-item');
    }

    updateSelectedVariantId(e, variantId) {
      if (e.target.closest('.bundle-grid-v2--product-card')) {
        e.target.closest('.bundle-grid-v2--product-card').dataset.selectedVariantId = variantId;
        this.updateQtyInputValue(e.target.closest('.bundle-grid-v2--product-card'), variantId);
      }
    }

    updateQtyInputValue(productCard, variantId) {
      let match = this.getMatchingLineItem(variantId);

      const ctaInput = productCard.querySelector('.item-qty-input');
      let qty = 0;

      if (match) {
        const lineItemInput = match.querySelector('.item-qty-input');
        qty = Number(lineItemInput.value);
      }

      ctaInput.value = qty;
      ctaInput.setAttribute('value', qty);
    }

    getMatchingLineItem(variantId) {
      const currentLineItems = [...this.getCurrentLineItems()];

      let match = false;
      currentLineItems.some((item) => {
        if (Number(item.dataset.variantId) === Number(variantId)) {
          match = item;
        }
      });

      return match;
    }

    addItem(data) {
      const { heading, image, variant, refill } = data;
      const currencyHelper = (data) => document.querySelector('bundle-builder-v2').toLocaleCurrencyStr(data);

      console.debug('addItem data:', { variant, refill });

      let match = this.getMatchingLineItem(variant.id);

      if (match) {
        console.info('Added item match', match.dataset);
        console.info('Should not be here');
        return;
      } else {
        console.info('No added item match, creating new line item');

        const itemImage = variant.featured_image?.src || image;

        // create new line item
        const lineItem = document.createElement('bundle-line-item-v2');
        lineItem.append(document.getElementById('bundle-builder-lineitem-template').content.cloneNode(true)); // using template saved in the HTML

        lineItem.className = 'line-item show';
        lineItem.dataset.title = variant.title;
        lineItem.dataset.variantId = variant.id;
        lineItem.dataset.quantity = 1;
        lineItem.dataset.price = variant.price;
        // TODO: tighten this up, no guarantees there'll always be an item in the array, even though it should
        lineItem.dataset.sellingPlanPrice = variant.selling_plan_allocations[0].price;
        lineItem.dataset.sellingPlanId = variant.selling_plan_allocations[0].selling_plan_id;
        lineItem.dataset.compareAtPrice = variant.compare_at_price;
        lineItem.dataset.priceSubtotal = variant.price;
        lineItem.dataset.planPriceSubtotal = variant.selling_plan_allocations[0].price;
        lineItem.dataset.compPriceSubtotal = variant.compare_at_price;

        lineItem.querySelector('.item-title').innerHTML = heading;
        lineItem.querySelector('.item-price .strike-price').innerHTML = currencyHelper(variant.compare_at_price / 100);
        lineItem.querySelector('.item-price .price').innerHTML = currencyHelper(
          (this.isSubscribed() ? variant.selling_plan_allocations[0].price : variant.price) / 100,
        );

        lineItem.querySelector('img').setAttribute('src', itemImage);

        if (variant.option1) {
          lineItem.querySelector('.item-options ul').insertAdjacentHTML('beforeend', `<li>${variant.option1}</li`);
        }
        if (variant.option2) {
          lineItem.querySelector('.item-options ul').insertAdjacentHTML('beforeend', `<li>${variant.option2}</li`);
        }
        if (variant.option3) {
          lineItem.querySelector('.item-options ul').insertAdjacentHTML('beforeend', `<li>${variant.option3}</li`);
        }

        document.querySelector('bundle-sticky-bar-v2 .line-items-wrapper').appendChild(lineItem);
      }
    }

    updateAccessoriesImage(productCard, imageSrc) {
      function replaceImageUrls(html, newUrl) {
        const updatedHtml = html.replace(/(srcset=["'])[^"']+(["'])/g, (match, p1, p2) => {
          return `${p1}${newUrl}?amp;width=165 165w,${newUrl}?amp;width=360 360w,${newUrl}?amp;width=533 533w,${newUrl}?amp;width=720 720w,${newUrl}?amp;width=940 940w,${newUrl}?v=1719583267 1000w${p2}`;
        });

        return updatedHtml.replace(/(src=["'])[^"']+(["'])/g, (match, p1, p2) => {
          return `${p1}${newUrl}?amp;width=533${p2}`;
        });
      }

      const originalImg = productCard.querySelector('img.motion-reduce');
      const parent = originalImg.parentElement;

      // Create spinner element
      const spinner = document.createElement('div');
      spinner.className = 'loading-spinner';

      // Insert spinner after the image
      parent.insertBefore(spinner, originalImg.nextSibling);

      // Set parent positioning if needed
      const computedStyle = window.getComputedStyle(parent);
      if (computedStyle.position === 'static') {
        parent.style.position = 'relative';
      }

      // Replace the image
      const html = originalImg.outerHTML;
      const newHtml = replaceImageUrls(html, imageSrc);
      originalImg.outerHTML = newHtml;

      // Get new image reference
      const newImg = productCard.querySelector('img.motion-reduce');

      // Handle image load/error
      if (newImg.complete) {
        spinner.remove();
      } else {
        newImg.addEventListener('load', () => spinner.remove());
        newImg.addEventListener('error', () => spinner.remove());
      }
    }

    saveCurrentStep() {
      let currentStep = Number(document.querySelector('input[name="steps"]:checked').dataset.stepIndex);
      localStorage.setItem('bbv2_current_step', currentStep);
    }

    loadCurrentStep() {
      let savedStep = localStorage.getItem('bbv2_current_step');
      if (savedStep) {
        this.querySelector(`input[name="steps"][data-step-index="${savedStep}"]`).click();
      } else {
        this.querySelector('input[name="steps"][data-step-index="1"]').click();
      }
    }

    resetCurrentStep() {
      localStorage.setItem('bbv2_current_step', 1);
    }

    isSubscribed() {
      return document.querySelector('bundle-builder-v2').isSubscribed();
    }
  },
);

customElements.define(
  'bundle-sticky-bar-v2',
  class BundleStickyBarV2 extends HTMLElement {
    #buildVersion = 1;
    connectedCallback() {
      this.observer.observe(this.querySelector('.line-items-wrapper'), {
        childList: true,
        characterData: true,
        subtree: true,
      });

      window.addEventListener('resize', () => {
        this.updateMoreItemsCounter();
      });

      this.loadLineItems();

      this.updatePreviewPanel();
      this.updateMoreItemsCounter();
      this.updateTotalPrice();

      this.addEventListener('click', this.clickHandler.bind(this));
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    observer = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        const target = mutation.target;

        if (mutation.type === 'childList') {
          if (
            mutation.addedNodes[0]?.className === 'line-item show' ||
            target?.className === 'strike-price' ||
            mutation.removedNodes[0]?.className === 'line-item'
          ) {
            this.updatePreviewPanel();
            this.updateTotalPrice();
            this.saveLineItems();
          }

          // TODO: replace this with an pub/sub event to decouple
          if (mutation.addedNodes[0]?.className === 'line-item show') {
            document
              .querySelector(
                `.bundle-grid-v2--product-card[data-selected-variant-id="${mutation.addedNodes[0].dataset.variantId}"]`,
              )
              .querySelector('.item-qty-input').value = 1;
          }

          if (mutation.removedNodes[0]?.className === 'line-item') {
            document.querySelector('bundle-builder-v2').updateData('line-item-deleted', {
              lineItems: Array.from(this.getLineItems()),
              deletedItem: Number(mutation.removedNodes[0]?.dataset.variantId),
            });
          }

          if (this.getLineItems().length === 0) {
            document.querySelector('bundle-builder-grid-v2').resetCurrentStep();
          }
        }
      }
    });

    clickHandler(e) {
      if (e.target.closest('.cta-hover-effect')) {
        let currentStep = Number(e.target.closest('.cta-hover-effect').dataset.currentStep);

        if (currentStep < 4) {
          document
            .querySelector(`bundle-builder-grid-v2 input[name="steps"][data-step-index="${currentStep + 1}"]`)
            .click();
        }

        if (currentStep === 4) {
          // display checkout modal
          document.querySelector('bundle-builder-checkout-v2').classList.toggle('checkout-active');
        }
      }
    }

    getLineItems() {
      return this.querySelectorAll('.line-item');
    }

    updatePreviewPanel() {
      let lineItems = this.getLineItems();
      let images = Array.from(lineItems)
        .map((v) => v.querySelector('img').src)
        .slice(-5)
        .reverse();

      // clear slots and refill
      let slots = this.querySelectorAll('.item-slot');

      slots.forEach((slot, i) => {
        slot.innerHTML = '';
        if (images[i]) {
          const img = document.createElement('img');
          img.src = images[i];
          slot.appendChild(img);
        }
      });

      this.querySelector('.items-total-counter .count').innerHTML = `(${lineItems.length})`;

      this.updateMoreItemsCounter();
    }

    updateMoreItemsCounter() {
      let lineItems = this.getLineItems();
      if (window.innerWidth < 1201 && lineItems.length > 3) {
        this.querySelector('.more-items-counter .count').innerHTML = `+${lineItems.length - 3}`;
      } else if (lineItems.length > 4) {
        this.querySelector('.more-items-counter .count').innerHTML = `+${lineItems.length - 4}`;
      }
    }

    updateTotalPrice() {
      const currencyHelper = (data) => document.querySelector('bundle-builder-v2').toLocaleCurrencyStr(data);

      let lineItems = Array.from(this.getLineItems());

      let subtotal = lineItems.reduce((acc, element) => {
        let value = parseFloat(element.dataset.priceSubtotal) || 0;
        return acc + value;
      }, 0);

      let planSubtotal = lineItems.reduce((acc, element) => {
        let value = parseFloat(element.dataset.planPriceSubtotal) || 0;
        return acc + value;
      }, 0);

      let compSubtotal = lineItems.reduce((acc, element) => {
        const value = parseFloat(element.dataset.compPriceSubtotal) || 0;
        return acc + value;
      }, 0);

      this.querySelector('.secondary-container .subtotal .price').innerHTML =
        `${currencyHelper((this.isSubscribed() ? planSubtotal : subtotal) / 100)}`;
      this.querySelector('.secondary-container .subtotal .strike-price').innerHTML =
        `${currencyHelper(compSubtotal / 100)}`;

      document.querySelector('bundle-builder-v2').updateData('drawer-updated', {
        lineItems,
        totals: { subtotal, planSubtotal, compSubtotal },
      });

      return { subtotal, planSubtotal, compSubtotal };
    }

    saveLineItems() {
      const lineItems = this.querySelector('.line-items-wrapper').innerHTML;

      if (lineItems) {
        localStorage.setItem('bbv2_build_version', this.#buildVersion);
        localStorage.setItem('bbv2_build_date', new Date().toISOString());
        localStorage.setItem('bbv2_line_items', lineItems);
      } else {
        console.error('Element not found');
      }
    }

    loadLineItems() {
      const lineItems = localStorage.getItem('bbv2_line_items');

      function daysBetween(date1String, date2String) {
        var d1 = new Date(date1String);
        var d2 = new Date(date2String);
        return (d2 - d1) / (1000 * 3600 * 24);
      }

      if (lineItems) {
        // abort loading data if these values don't exist
        if (!localStorage.getItem('bbv2_build_version')) return;
        if (!localStorage.getItem('bbv2_build_date')) return;

        // abort if version mismatch
        if (parseInt(localStorage.getItem('bbv2_build_version')) !== this.#buildVersion) return;

        // abort loading data if it's older than 'daysLimit'
        const daysLimit = 14;
        if (daysBetween(localStorage.getItem('bbv2_build_date'), new Date().toISOString()) > daysLimit) return;

        this.querySelector('.line-items-wrapper').innerHTML = lineItems;
        this.updateTotalPrice();

        // const sidebarItems = document.querySelector('.mobile-bottom-drawer .item_count');
        // if (sidebarItems.children?.length === 3) {
        //   sidebarItems.outerHTML = bundleBuilderItems;

        //   // click on subscription option
        //   document.querySelector('label[for="sub_radio"]').click();

        //   this.updatePriceCalculations({ loadSavedBundle: { bundleBuilderItems, self } });

        //   try {
        //     const clearCartBundleItems = this.clearBundleItemsFromCart;
        //     var timer = setInterval(waitForCart, 1000);

        //     function waitForCart() {
        //       if (window.cart?.getCart()) {
        //         clearInterval(timer);
        //         clearCartBundleItems();
        //         return;
        //       }
        //     }
        //   } catch (error) {
        //     console.error(error);
        //   }
        // }
      }
    }

    isSubscribed() {
      return document.querySelector('bundle-builder-v2').isSubscribed();
    }
  },
);

customElements.define(
  'bundle-line-item-v2',
  class BundleBuilderLineItemV2 extends HTMLElement {
    connectedCallback() {
      this.querySelector('.item-remove-button svg').addEventListener('click', this.removeItem.bind(this));
    }

    disconnectedCallback() {
      this.querySelector('.item-remove-button svg').removeEventListener('click', this.removeItem);
    }

    removeItem() {
      this.classList.remove('show');
      setTimeout(() => {
        this.ontransitionend = this.remove();
      }, 350);
    }
  },
);

// Use class inheritance
// Define base quantity box class methods
// Extend to drawer and grid component versions, inputChangeHandler in extension classes
class BundleBuilderItemQuantity extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector('input').addEventListener('change', this.inputChangeHandler.bind(this));
    this.addEventListener('click', this.buttonClickHandler);
  }

  disconnectedCallback() {
    this.querySelector('input').removeEventListener('change', this.inputChangeHandler);
    this.querySelector('button').removeEventListener('click', this.buttonClickHandler);
  }

  buttonClickHandler(e) {
    if (e.target.tagName === 'BUTTON') {
      if (e.target.classList.contains('cta-hover-effect')) return;

      const currentValue = parseInt(this.querySelector('input').value);
      const operation = e.target.className;

      let newValue = currentValue;
      if (operation === 'plus-quantity') {
        newValue++;
      } else if (operation === 'minus-quantity') {
        newValue--;
      }

      if (newValue !== 0) {
        this.querySelector('input').value = newValue;
        this.querySelector('input').dispatchEvent(new Event('change'));
      } else {
        e.srcElement.offsetParent.querySelector('.item-remove-button').click();
      }
    }
  }
}

customElements.define(
  'bundle-v2-quantity-box',
  class BundleBuilderLineItemQuantity extends BundleBuilderItemQuantity {
    constructor() {
      super();
    }

    inputChangeHandler(e) {
      const currencyHelper = (data) => document.querySelector('bundle-builder-v2').toLocaleCurrencyStr(data);

      const lineItem = this.closest('bundle-line-item-v2');

      const qty = Number(e.target.value);
      e.target.setAttribute('value', qty);

      const listPrice = Number(lineItem.dataset.price) * qty;
      const sellingPlanPrice = Number(lineItem.dataset.sellingPlanPrice) * qty;
      const compPrice = Number(lineItem.dataset.compareAtPrice) * qty;

      lineItem.dataset.quantity = qty;

      lineItem.dataset.priceSubtotal = listPrice;
      lineItem.dataset.planPriceSubtotal = sellingPlanPrice;
      lineItem.dataset.compPriceSubtotal = compPrice;

      lineItem.querySelector('.item-price .price').innerHTML = currencyHelper(
        (this.isSubscribed() ? sellingPlanPrice : listPrice) / 100,
      );
      lineItem.querySelector('.item-price .strike-price').innerHTML = currencyHelper(compPrice / 100);
    }

    isSubscribed() {
      return document.querySelector('bundle-builder-v2').isSubscribed();
    }
  },
);

customElements.define(
  'bundle-v2-grid-quantity-box',
  class BundleBuilderGridItemQuantity extends BundleBuilderItemQuantity {
    constructor() {
      super();
    }

    inputChangeHandler(e) {
      let productCard = e.target.closest('.bundle-grid-v2--product-card');
      const variantId = Number(productCard.dataset.selectedVariantId);
      const value = Number(e.target.value);
      const lineItem = document.querySelector(`bundle-sticky-bar-v2 [data-variant-id="${variantId}"]`);
      const lineItemQty = Number(lineItem.dataset.quantity);

      // console.debug({
      //   variantId,
      //   card: productCard,
      //   qty: Number(e.target.value),
      //   lineItem: document.querySelector(`bundle-sticky-bar-v2 [data-variant-id="${variantId}"]`),
      //   value,
      //   lineItemQty,
      // });

      if (value === lineItemQty) return;

      if (value > lineItemQty) {
        lineItem.querySelector('.plus-quantity').click();
      } else {
        lineItem.querySelector('.minus-quantity').click();
      }
    }
  },
);

customElements.define(
  'bundle-builder-checkout-v2',
  class BundleBuilderCheckoutV2 extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.clickHandler.bind(this));

      // listen for updates from drawer
      document.querySelector('bundle-builder-v2').addEventListener('drawer-updated', (event) => {
        console.debug('drawer-updated event received by checkout modal component', { event });

        // update prices
        if (event?.detail?.totals) {
          const { compSubtotal, planSubtotal, subtotal } = event.detail.totals;
          const currencyHelper = (data) => document.querySelector('bundle-builder-v2').toLocaleCurrencyStr(data);

          this.querySelector('label[for="subscription"] .strike-price').innerHTML = currencyHelper(compSubtotal / 100);
          this.querySelector('label[for="subscription"] .price').innerHTML = currencyHelper(planSubtotal / 100);
          this.querySelector('label[for="one-time"] .price').innerHTML = currencyHelper(subtotal / 100);

          this.querySelector('.subtotal-row .price').innerHTML = currencyHelper(
            (this.isSubscribed() ? planSubtotal : subtotal) / 100,
          );
          this.querySelector('.subtotal-row .strike-price').innerHTML = currencyHelper(compSubtotal / 100);

          this.updateSavingsAmount(event.detail.totals);
        }
      });

      document.querySelector('bundle-sticky-bar-v2').updateTotalPrice();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.clickHandler);
    }

    clickHandler(e) {
      if (e.target.closest('.overlay')) {
        this.classList.toggle('checkout-active');
      }

      if (e.target.closest('input[name="checkout-plan"]')) {
        document.querySelector('bundle-sticky-bar-v2').updateTotalPrice();
      }

      if (e.target.closest('.checkout-modal-cta')) {
        let payload = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: document.querySelector('bundle-builder-v2').items }),
        };

        this.sendCheckoutPayload(payload);
      }
    }

    sendCheckoutPayload(payload) {
      fetch(window.Shopify.routes.root + 'cart/add.js', payload)
        .then((response) => {
          return response.json();
        })
        // .then((results) => {
        //   console.debug({ results }); // debug add to cart response
        // })
        .finally(() => {
          return (window.location.href = '/checkout');
        })
        .catch((e) => {
          console.error(e);
        });
    }

    updateSavingsAmount(data) {
      const { compSubtotal, planSubtotal, subtotal } = data;
      const oneTimeSavings = compSubtotal - subtotal;
      const subscriptionSavings = compSubtotal - planSubtotal;
      const discountPercent = Math.round(((compSubtotal - planSubtotal) / compSubtotal) * 100);
      const currencyHelper = (data) => document.querySelector('bundle-builder-v2').toLocaleCurrencyStr(data);

      this.querySelector('.plan-price .discount-label').innerHTML = `Save ${discountPercent}%`;
      this.querySelector('.total-savings-row .price').innerHTML =
        `${this.isSubscribed() ? currencyHelper(subscriptionSavings / 100) : currencyHelper(oneTimeSavings / 100)}`;
    }

    isSubscribed() {
      return document.querySelector('bundle-builder-v2').isSubscribed();
    }
  },
);
